import React, { PropTypes, Component } from 'react';
import { mixin, RefluxMixin } from 'Util';
import DiscountDetail from 'components/Route/Discount/Detail';
import { DiscountStore } from 'stores';
import DiscountActions from 'actions/Discount';
import Loader from 'components/Material/Loader';

class DiscountDetailContainer extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  listenToStores() {
    this.listenToStore(DiscountStore);
  }

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    DiscountActions.findById(this.props.params.discountId);
  }

  // shouldComponentUpdate(nextProps, nextState) {
  //   return (this.props.routeParams.discountId !== nextProps.routeParams.discountId) || (this.state.discount !== nextState.discount);
  // }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.routeParams.discountId !== nextProps.routeParams.discountId
    ) {
      DiscountActions.findById(nextProps.routeParams.discountId);
    }
  }

  goBack = () => {
    this.props.router.push(`/discounts`);
    DiscountActions.read();
  };

  render() {
    const { discount } = this.state;
    if (!discount) {
      return <Loader />;
    }
    return <DiscountDetail discount={discount} onClose={this.goBack} />;
  }
}

export default DiscountDetailContainer;



// WEBPACK FOOTER //
// ./src/js/components/Route/Discount/DiscountDetailContainer.js